<template>
  <div class="bg-light-gray px-4">
    <div class="row">
      <div class="col-12 mb-3 ">
        <icon-view
          :has-border="false"
          icon="fas fa-user-times text-orange"
          icon-size="17px"
          title="Registrar Ausencia"
          variant="custom-icon-view"
          icon-background="#ffffff p-5"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md-3">
          <custom-date-picker
            v-model="model.date"
            required
            label="Fecha"
            placeholder="DD/MM/YYYY"
            class="cd"
            disabled
          />
        </div>
        <div class="col-12 col-md-3">
          <custom-time-picker
            v-model="model.start"
            label="Desde:"
            disabled
            class="custom-datetime-picker-container"
          />
        </div>
        <div class="col-12 col-md-3">
          <custom-time-picker
            v-model="model.end"
            label="Hasta:"
            disabled
            class="custom-datetime-picker-container"
          />
        </div>
        <div class="col-12 col-md-3">
          <label data-v-11da8640="" class="data-label">CAAT:</label>
          <input
            type="text"
            class="form-control"
            v-model="model.caat"
            disabled
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-2 pt-3">
          <icon-view
            :has-border="false"
            icon="fas fa-user-circle text-orange"
            icon-size="30px"
            title="Participantes"
            variant="custom-icon-view"
            icon-background="#ffffff p-5"
          />
        </div>
        <div class="col-12 mb-2 pl-4 pt-3">
          <custom-result-not-found
            v-if="model.participants.length == 0"
            class="mt-4 row pt-3"
            text="No hay Información Disponible."
          />
          <div v-else class="row">
            <div
              v-for="(item, key) in model.participants"
              :key="key"
              class="col-12 col-lg-3 bg-white rounded p-4 mr-2 mt-1"
            >
              <p class="font-14">{{ item.fullName }}</p>
              <p class="font-14 text-gray">
                Especialista de Asistencia Tecnológica / {{ item.companyName }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 mb-2 pl-4 pt-3">
          <div class="row">
            <div class="col-12">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  :options="listOfReasons"
                  label="Razón:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione una razón"
                  class="w-50 mb-4 w-25 bold-label"
                  v-model="model.reasonId"
                  custom-error-msg="Este campo es requerido."
                  :error="errors[0] ? 'err' : ''"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="col-12 mb-2 pl-4 pt-3">
          <div class="row">
            <div class="col-12">
              <div>
                <label class="data-name font-16">Comentario:</label>
              </div>
              <custom-text-area
                v-model="model.comment"
                class="mb-2"
                :count-classes="['d-block text-right']"
                :maxlength="3000"
                :show-char-count="true"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('cancel')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSaveAbsence"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from '@quisit/custom-text-area';
import CustomTimePicker from 'custom-time-picker';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import CustomResultNotFound from 'custom-result-not-found';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import appointmentStatus from '@/utils/constants/appointmentStatus';

export default {
  name: 'RegisterAbsence',
  components: {
    ActionButton,
    IconView,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
    CustomTimePicker,
    CustomResultNotFound,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    referral: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    listOfReasons: [],
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    Promise.all([this.getReaons(), this.getAppointment()]);
  },
  methods: {
    async getReaons() {
      try {
        const {
          data,
        } = await referralAndEquipmentsservice.getAbsenceStatusReasons();
        this.listOfReasons = data;
      } catch (err) {
        if (err && err.response && err.response.data) {
          this.ShowToast('Error', err.response.data.message, 'error');
        } else {
          this.ShowToast('Error', err.message, 'error');
        }
      }
    },
    async getAppointment() {
      const {
        data: appoitment,
      } = await referralAndEquipmentsservice.getAppointmentByStatus(
        this.referral.id,
        appointmentStatus.Coordinate
      );

      const hourStart = appoitment.start.split('T')[1];
      const hourEnd = appoitment.end.split('T')[1];
      this.model = {
        ...this.model,
        date: appoitment.date,
        start: hourStart,
        end: hourEnd,
        participants: appoitment.participants,
        caat: appoitment.caat,
        appointmentId: appoitment.appointmentId,
      };
    },
    async handlerSaveAbsence() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      this.$emit('save');
    },
  },
};
</script>

<style lang="scss" scoped>
input[type='text'] {
  border: 1px solid #dedede;
  background: #f8f8fa;
}

::v-deep .dot {
  padding: 19px !important;
}

::v-deep {
  .custom-datetime-picker-container.width-container,
  .custom-time-picker-container.width-container {
    width: 100% !important;

    & span > div > div.input-group > input {
      border: 1px solid #dedede;
      background: #f8f8fa;
    }

    & .dropdown > input {
      border: 1px solid #dedede !important;
      background: #f8f8fa !important;
    }
  }
}

::v-deep {
  .data-label,
  .data-name {
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    color: #727272;
  }
}
</style>
